import { FC } from 'react';
import { BoxDetailProductType } from '../../types/view/BoxDetailType';
import { ProductGridCell } from './ProductGridCell';

export const ProductGrid: FC<{
  products: BoxDetailProductType[];
  maxQuantity: number;
  onClickProductLink: (variantId: number) => void;
  onChangeQuantity: (variantId: number, quantity: number) => void;
  onLoadImg: () => void;
}> = ({ products, maxQuantity, onClickProductLink, onChangeQuantity, onLoadImg }) => {
  const productsHtml = products.map((product, idx) => (
    <ProductGridCell
      product={product}
      maxQuantity={maxQuantity}
      onClickProductLink={onClickProductLink}
      onChangeQuantity={onChangeQuantity}
      onloadImg={onLoadImg}
      key={`grid-${idx}`}
    />
  ));

  return (
    <>
      <div
        className="grid-collection"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        }}
      >
        {productsHtml}
      </div>
    </>
  );
};
